export default {
      id: "patient-details-usage",
      viewBox: "0 0 52 52",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#patient-details",
      toString: function () {
        return this.url;
      }
    }